{
    "ReportPortalInfo_UpgradeTo_Enterprise": "Atualizar para Enterprise para aceder a esta funcionalidade",
    "ReportPortalInfo_UpgradeTo_Enterprise_MST": "Atualize para o CXA Avançado (Histórico) para aceder esta funcionalidade",
    "ReportPortalInfo_UpgradeTo_Call Centre Supervisor": "Atualização para Supervisor do Call Center para aceder a esta funcionalidade",
    "ReportPortalInfo_UpgradeTo_Call Centre Supervisor_MST": "Atualização para CXA Avançado para aceder a esta funcionalidade",
    "NAME": "ReportPortalInfo"
}